import { useState, useEffect } from 'react';
import { HostBackend } from '../../Routes/HostBackend.js';
import { GetHeaders } from '../../Components/Admin/Functions/FetchHeaders.js';
import { CarrouselDatas } from '../../Components/Public/Carrousel/CarrouselDatas.js';
import { CarrouselTotal } from '../../Components/Public/Carrousel/CarrouselTotal.js';
import { GetDescription } from '../../Components/Public/Functions/GetDescription.js';
import { ScrollTop } from '../../Components/Public/Functions/ScrollTop.js';
/* document */
import { Navigation } from '../../Components/Public/Document/Navigation.js';
import { Header } from '../../Components/Public/Document/Header.js';
import { Footer } from '../../Components/Public/Document/Footer.js';
import { BreadCrumb } from '../../Components/Public/Document/Breadcrumb.js';
import { Carrousel } from '../../Components/Public/Carrousel/Carrousel.js';
import { AnimCarrousel } from '../../Components/Public/Functions/AnimCarrousel.js';
import { BlockLogoAttraction } from '../../Components/Public/Logos/BlockLogoAttraction.js';
import { InfosAttraction } from '../../Components/Public/Blocks/InfosAttraction.js';
import { BlockTitleDate1Link2 } from '../../Components/Public/Blocks/BlockTitleDate1Link2.js';
import { BlockOutlink } from '../../Components/Public/Blocks/BlockOutlink.js';
import { BackTop } from '../../Components/Public/Document/BackTop.js';

export const Attraction = (props) => {
    const { navParks, id } = props;
    const backend = HostBackend();
    const guest = sessionStorage.getItem('guest');
    const [attraction, setAttraction] = useState([]);
    useEffect(() => {
        const fetchtheData = async () => {
            const dataAttraction = await fetch(`${backend}/attraction?id=${id}`, GetHeaders(guest));
            const attraction = await dataAttraction.json();
            setAttraction(attraction);
        };
        fetchtheData();
        ScrollTop();
        AnimCarrousel();
    }, [backend, id, guest]);
    const carrouselDatas = CarrouselDatas('attraction', attraction);
    const carrouselTotal = CarrouselTotal('attraction', attraction);
    const items = GetDescription('attraction', { attraction: attraction })
    return (
        <div className="attraction">
            <Navigation navParks={navParks} />
            <Header />
            <Carrousel label="attraction" datas={carrouselDatas} total={carrouselTotal} />
            <BreadCrumb label="attraction" />
            <section className="infos">
                {attraction.map((item, i) => {
                    return (
                        <div className="bloc-infos" key={i}>
                            <BlockLogoAttraction label="attraction" item={item} />
                            <InfosAttraction datas={attraction} />
                        </div>
                    )
                })}
                <div className="description">
                    <BlockTitleDate1Link2 label="attraction" items={items} />
                    <p>{items.description}</p>
                    <BlockOutlink items={items} />
                </div>
            </section>
            <BackTop />
            <Footer />
        </div>
    )
}